import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../store/authStore"; 
import { AccessDeniedDialog } from "../components/AccessDeniedDialog";

interface ProtectedRouteProps {
  roles?: string[];
  excludeRoles?: string[];
  module?: string;
  children?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, roles, excludeRoles, module }) => {
  const { user, isAuthenticated } = useAuthStore();
  
  // 1. Giriş Kontrolü
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const userRole = user?.role;
  const userRoleName = userRole?.name;
  const firmModules = (user as any)?.firmModules;

  // Super Admin her yere girebilir
  if (userRoleName === "super_admin") {
    return children ? <>{children}</> : <Outlet />;
  }

  // 2. Rol Kontrolü
  if (roles && roles.length > 0) {
    if (!roles.includes(userRoleName || "")) {
      return <AccessDeniedDialog moduleName="Kullanıcı Rolü Yetersiz" />;
    }
  }

  if (excludeRoles && excludeRoles.length > 0) {
    if (excludeRoles.includes(userRoleName || "")) {
      return <AccessDeniedDialog moduleName="Kullanıcı Rolü Yetersiz" />;
    }
  }

  // 3. Modül ve Firma Abonelik Kontrolü
  if (module) {
    // A: Firma bu modüle sahip mi?
    const isFirmSubscribed = firmModules ? firmModules[module] === true : false;
    
    // B: Kullanıcının bu modülde OKUMA (canRead) yetkisi var mı?
    const hasUserReadAuth = userRole?.permissions?.some(
      (p: any) => p.module === module && p.canRead === true
    );

    // C: Paket Süresi Kontrolü (Opsiyonel)
    const isExpired = firmModules?.expiresAt && new Date(firmModules.expiresAt) < new Date();

    if (!isFirmSubscribed) {
      return <AccessDeniedDialog moduleName={`Paketinizde Bulunmuyor: ${module}`} />;
    }

    if (isExpired) {
      return <AccessDeniedDialog moduleName={`Modül Kullanım Süresi Dolmuş: ${module}`} />;
    }

    if (!hasUserReadAuth) {
      return <AccessDeniedDialog moduleName={`Görüntüleme Yetkiniz Yok: ${module}`} />;
    }
  }

  return children ? <>{children}</> : <Outlet />;
};